import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import "./ConsultantDirectory.scss"
import { styled } from "@mui/material/styles"
import { COLUMNS } from "./ConsultantColumns"
import React, { useEffect, useState, useRef } from "react"
import { useHistory } from "react-router"
import {
  getAllConsultantReferralDetails,
  getAllConsultants,
  getAvailability
} from "../../../core/services/api"
import ReferralConsultant from "./ReferralConsultant"
import Table from "../../../components/Table"
import { useSelector } from "react-redux"
import PrintConsultantDirectory from "./PrintConsultantDirectory"
import Print from "components/Print/Print"


const CustomTab1 = styled(Tab)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  textTransform: "none",
  color: "white",
  width: "246px",
  height: "56px",
  boxShadow: "0px 3px 8px #005AEA5E",
  borderRadius: "13px 13px 0px 0px",
  opacity: "1",
  fontSize: "20px",
  "&.Mui-selected": {
    color: "white",
  },
}))

const CustomTab2 = styled(Tab)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  textTransform: "none",
  marginLeft: "20px",
  color: "white",
  width: "246px",
  height: "56px",
  boxShadow: "0px 3px 8px #005AEA5E",
  borderRadius: "13px 13px 0px 0px",
  opacity: "1",
  fontSize: "20px",
  "&.Mui-selected": {
    color: "white",
  },
}))

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function TabPanel(props: any) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}


export default function ConsultantDirectory() {

  const activeTabStyle = {
    backgroundColor: "#024CF2",
    color: "white",
  };

  const inactiveTabStyle = {
    backgroundColor: "#BDC6D9",
    color: "white",
  };

  const [data, setData] = useState<any>([])
  const [refData, setrefData] = useState([])
  const [value, setValue] = React.useState(0)
  const [cwa, setCwa] = useState<any>()
  const [avail, setavail] = useState<any>()

  const componentRef: any = useRef<any>(null)
  const history = useHistory()

  //Consultant API fetch Details
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const getAvail = (availTF: any) => {
    let obj: any = []
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ]
    const today = new Date()
    const dayOfWeek = daysOfWeek[today.getDay()]
    Object.keys(availTF).map((each: any) => {
      if (each.startsWith(dayOfWeek.toUpperCase())) {
        obj.push(availTF[each])
      }
    })

    return obj.sort()
  }

  function redirectTo(path: any) {
    history.push(`/consultant/${path}`)
  }

  useEffect(() => {
    getAvailability(`?centerId=${userDetail?.currentCenter?.centerId}`).then(
      (res) =>
        setavail(res)
    )

    getAllConsultants(`/consultants?centerId=${userDetail?.currentCenter?.centerId}`)
      .then((res) => {
        setData(res)
      })
      .catch((err) => {
        console.error("err", err)
      })

    getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId ? userDetail?.currentCenter?.centerId : "")
      .then((res) => {
        setrefData(res)
      })
      .catch((err) => {
        console.error("err", err)
      })
  }, [])

  useEffect(() => {
    if (avail?.length > 0 && data?.length > 0) {
      let arr: any[] = []
      data?.map((eachConsultant: any) => {
        const avlOfCons = avail.find(
          (eachObj: any) => eachConsultant?.id === eachObj?.consultantId
        )
        let temp = Object.assign({}, eachConsultant)
        if (avlOfCons?.availabilityTimeFrame && Object.keys(avlOfCons?.availabilityTimeFrame)?.length > 0)
          temp["availabilityTimeFrame"] = getAvail(
            avlOfCons?.availabilityTimeFrame
          )
        arr.push(temp)
      })
      setCwa(arr)
    }
  }, [data, avail])

  return (
    <div className="consultant-wrapper">
      <Box sx={{ padding: "0", margin: "auto" }}>
        <style type="text/css" media="print"></style>
        <div className="consultant-heading">Consultants</div>
        <Box
          sx={{
            borderBottom: 3,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{}}
          >
            <CustomTab1 label="In House" {...a11yProps(0)}
              sx={value === 0 ? activeTabStyle : inactiveTabStyle}
            />
            <CustomTab2 label="Referral Doctors" {...a11yProps(1)}
              sx={value === 1 ? activeTabStyle : inactiveTabStyle}
            />
            <div
              className="total"
              style={{ position: "absolute", right: "0", top: "20px" }}
            >
              <div
                style={{
                  height: "100% !important",
                  width: "100%",
                  overflow: "visible",
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  alignItems: "center",
                }}
              >
                <div className="consultant-count d-flex">
                  Total Consultants:
                  <div className="count">
                    {value === 0 ? data.length : refData.length}
                  </div>
                </div>
                <Print
                  componentRef={componentRef}
                />
              </div>
              <PrintConsultantDirectory
                printRef={componentRef}
                invoice={cwa?.length > 0 ? cwa : data}
                value={value}
              />
            </div>
          </Tabs>
        </Box>

        {/* For In House Doctors */}

        <TabPanel value={value} index={0}>
          <div className="consultant-directory-container">
            <Table
              data={cwa?.length > 0 ? cwa : data}
              columns={COLUMNS}
              globalFilterRequired={false}
              onRowClick={(id: any) => redirectTo(id)}
              style={{
                fontSize: "12px",
                textAlign: "initial",
                textTransform: "lowercase",
              }}
            />
          </div>
        </TabPanel>

        {/* For Referral Doctors */}
        <TabPanel value={value} index={1}>
          <ReferralConsultant data={refData} />
        </TabPanel>
      </Box>
    </div>
  )
}
